// extracted by mini-css-extract-plugin
module.exports = {"boxBtnAdd":"_1h0YDUL3xnHIfB27R-lS7z"};